import { Flex, Text } from '@chakra-ui/react';
import { faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IPeerReviewFirstAssessment } from '@publishing-engine/domain/models';
import { DisplayField } from 'src/components/shared/DisplayField';
import { MissingReference } from '../Submission/ReviewTab/MissingRefrence';
import FileViewerButtonText from '../Submission/FileViewerButtonText';

const ForAuthorReview = ({
  configs,
  reviewAssessment,
  submissionContextId
}: {
  configs: any;
  reviewAssessment: IPeerReviewFirstAssessment;
  submissionContextId?: string;
}) => {
  return (
    <Flex direction="column" gap={4}>
      <Text textStyle="headingGroup">For Authors</Text>
      {reviewAssessment?.feedbackForAuthors?.original && (
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="headingItem">Feedback for Authors</Text>
          <Text textStyle="textBody">
            {reviewAssessment?.feedbackForAuthors?.original}
          </Text>
        </Flex>
      )}

      {(reviewAssessment?.reviewerAttachments?.length ?? 0) >= 1 && (
        <Flex direction="column">
          <Text textStyle="headingItem">Attachments for Authors</Text>
          {reviewAssessment?.reviewerAttachments?.map(attachment => (
            <Flex
              key={attachment.name}
              flexDirection="column"
              borderBottom="1px"
              padding={4}
              borderColor="neutralPrimaryBorder"
              gap={2}
            >
              <Flex
                flexDirection="row"
                justifyContent="space-between"
                width="100%"
              >
                <Flex gap={2} alignItems={'center'}>
                  <FontAwesomeIcon icon={faFile} size="lg" />
                  <Text
                    textStyle="textBody"
                    wordBreak={'break-word'}
                    whiteSpace={'normal'}
                  >
                    {attachment.name}
                  </Text>
                </Flex>
                <FileViewerButtonText
                  file={attachment}
                  submissionContextId={submissionContextId}
                  textStyle="textBody"
                  flexShrink={0}
                >
                  View
                </FileViewerButtonText>
              </Flex>
            </Flex>
          ))}
        </Flex>
      )}

      {configs?.missingReference && (
        <MissingReference
          config={configs.missingReference}
          missingReference={reviewAssessment?.missingReference || null}
        />
      )}

      {reviewAssessment?.articleWellWritten && (
        <DisplayField
          fieldName="articleWellWritten"
          value={reviewAssessment.articleWellWritten}
          config={configs}
        />
      )}
    </Flex>
  );
};

export default ForAuthorReview;
